"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledOption = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
var _react = require("react");
var colors = _interopRequireWildcard(require("../../../constants/colors"));
var _useTheme = require("../../../theme/utils/useTheme");
/** @jsxRuntime classic */
/** @jsx jsx */

const optionTheme = (0, _sdsThemeInternal.themed)({
  backgroundColor: {
    selected: {
      "lodestar-light": colors.neutralLight10,
      "ursa-light": colors.neutralLight10
    },
    hover: {
      "lodestar-light": colors.neutralLight10,
      "ursa-light": colors.neutralLight10
    },
    active: {
      "lodestar-light": colors.neutral,
      "ursa-light": colors.neutral
    }
  }
});
const StyledOption = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    className,
    height,
    isFocused,
    isSelected,
    // TODO When we have a style for disabled options, use this.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
    isDisabled = false,
    ...rest
  } = _ref;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const theme = key;
  const additionalStyles = (0, _core.css)`
            box-sizing: border-box;
            border-radius: 4px;
            color: ${colors.neutralDark30};
            cursor: pointer;
            display: block;
            font-size: 13px;
            height: auto;
            line-height: 18px;
            margin: 0 4px;
            min-height: ${height}px;
            overflow: hidden;
            padding: 11px 12px;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: 500;
            > * {
                white-space: normal;
            }

            &:hover {
                color: ${colors.neutralDark40};
                background-color: ${optionTheme.backgroundColor.hover(theme)};
            }

            ${isFocused && `background-color: ${optionTheme.backgroundColor.selected(theme)};`}

            &:active {
                background-color: ${optionTheme.backgroundColor.active(theme)};
            }
        `;
  return (0, _core.jsx)("div", (0, _extends2.default)({
    css: additionalStyles,
    className: className,
    "aria-selected": isSelected ? true : undefined,
    role: "option",
    ref: ref
  }, rest), children);
});
exports.StyledOption = StyledOption;
StyledOption.displayName = "StyledOption";
//# sourceMappingURL=StyledOption.js.map